export const createTabPageDescriptor = (type, loadPage) => ({
  type,
  loadPage,
});
